
import { defineComponent, ref, computed, onMounted, toRef } from "vue";
import { store } from "@/store";
import { ActionTypes } from "@/store/actions";
import { CurrentLabel } from "@/types";

export default defineComponent({
  name: "CustomLabelSizesButton",
  props: {
    idx: Number,
    isDisabled: Boolean,
  },
  setup(props) {
    const isDisabled = ref(false);
    onMounted(() => {
      if (props.isDisabled) {
        isDisabled.value = props.isDisabled;
      }
    });

    const idxRef = toRef(props, "idx");
    if (idxRef.value !== 0 && idxRef.value !== 1) {
      throw new Error("Missing necessary prop, CustomLabelSizesButton.vue");
    }

    const currentLabel = computed<CurrentLabel>(() => store.getters.currentLabel);

    const showCustomLabelSizesWidth = () => {
      store.dispatch(ActionTypes.SET_MODAL, "customLabelSizesWidth");
    };

    const showCustomLabelSizesHeight = () => {
      store.dispatch(ActionTypes.SET_MODAL, "customLabelSizesHeight");
    };

    return {
      idxRef,
      currentLabel,
      showCustomLabelSizesWidth,
      showCustomLabelSizesHeight,
    };
  },
});
